import { render, staticRenderFns } from "./UiMediaObject.vue?vue&type=template&id=4a0077ae&"
import script from "./UiMediaObject.vue?vue&type=script&lang=js&"
export * from "./UiMediaObject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports